import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });
http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("srm_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
http.interceptors.response.use((r) => r, (e) => {
  if (e?.response?.status === 401 && !e.config.url.includes("/auth/login")) window.dispatchEvent(new Event("srm-unauthorized"));
  return Promise.reject(e);
});

const nf1 = new Intl.NumberFormat("en-IN", { minimumFractionDigits: 1, maximumFractionDigits: 1 });

export const fmt = (v) => {
  if (v == null || Number.isNaN(v)) return "–";
  if (Math.abs(v) < 0.05) return "–";
  return v < 0 ? `(${nf1.format(-v)})` : nf1.format(v);
};
export const fmtCr = (v) => (v == null || Number.isNaN(v) ? "–" : `${v < 0 ? "−" : ""}₹${nf1.format(Math.abs(v))} Cr`);
export const pct = (v) => (v == null || !Number.isFinite(v) ? "–" : `${(v * 100).toFixed(1)}%`);
export const sum = (a) => (a || []).reduce((s, x) => s + (x || 0), 0);
export const cut = (arr, h) => (arr ? arr.slice(h.from, h.to + 1) : []);
export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Something went wrong";
export const last = (a) => (a && a.length ? a[a.length - 1] : 0);

export const PALETTE = ["#F59E0B", "#3B82F6", "#10B981", "#F43F5E", "#22D3EE", "#FB923C", "#A3E635", "#E879F9", "#94A3B8", "#FDE68A"];

export const downloadCsv = (filename, years, rows) => {
  const esc = (s) => `"${String(s ?? "").replace(/"/g, '""')}"`;
  const lines = [["Line item", ...years].map(esc).join(",")];
  rows.forEach((r) => {
    if (!r.values) lines.push(esc(r.label));
    else lines.push([esc(r.label), ...r.values.map((v) => (v == null ? "" : Number(v).toFixed(4)))].join(","));
  });
  const blob = new Blob([lines.join("\n")], { type: "text/csv" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
};
